import { Flex } from 'foundations-components/components/Flex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const UILoadingSpinnerCentered = () => /*#__PURE__*/_jsx(Flex, {
  justifyContent: "center",
  inlineSize: "full",
  marginBlock: "1200",
  children: /*#__PURE__*/_jsx(LoadingSpinner, {})
});
export default UILoadingSpinnerCentered;